import React from 'react';
import EllipsesControl from '../../../../../src/components/Common/EllipsesControl/EllipsesControl';

export default function AGGridEllipsesCellRenderer({value}) {
	return <EllipsesControl content={value} tooltip={value} noOfLines={1} />;
}
